import { render, staticRenderFns } from "./ThgVehicleClass.vue?vue&type=template&id=3a6af85d&scoped=true"
import script from "./ThgVehicleClass.vue?vue&type=script&lang=ts"
export * from "./ThgVehicleClass.vue?vue&type=script&lang=ts"
import style0 from "./ThgVehicleClass.vue?vue&type=style&index=0&id=3a6af85d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6af85d",
  null
  
)

export default component.exports